import { createSlice } from "@reduxjs/toolkit";
import { calculateAge } from "../helper/helper";
import { clearAddressData, setAddressDetailData } from "./addressSlice";
import { clearBankData, setBankDetailsData } from "./bankSlice";
import { clearBoidData, setBoidData, setBoidOtherData } from "./boidSlice";
import {
  clearDocumentData,
  resetDocumentListData,
  setDocumentListData,
} from "./documentSlice";
import {
  clearDynamicData,
  setDynamicFieldData,
  setDynamicFieldList,
} from "./dynamicFieldSlice";
import {
  clearFamilyData,
  resetFamilyDetailData,
  setFamilyDetailData,
} from "./familySlice";
import {
  clearGuardianData,
  setGuardianData,
  setGuardianDocumentListData,
} from "./guardianSlice";
import {
  clearOccupationData,
  resetOccupationInvestmentCompanyRelationList,
  resetOccupationInvetmentCompanyData,
  setOccupationDetailData,
} from "./occupationSlice";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import {
  disableSection,
  setMainRouterData,
  setSectionComplete,
} from "./routerSlice";
import {
  setBiometricsDetailsData
} from "./biometricsSlice";
import { setAntiMoneyLaunderingDetailData } from "./moneyLaunderingPreventionSlice";

export const personalDetailsSlice = createSlice({
  name: "personalDetails",
  initialState: {
    firstName: "",
    nationality: "NP",
    isDisabled: false,
    maritalStatus: "UM",
    dob: null,
    errors: {},
  },
  reducers: {
    setFirstName: (state, action) => {
      state.op = "U";
      state.firstName = action.payload;
      state.errors.firstNameError = {};
    },
    setMiddleName: (state, action) => {
      state.op = "U";
      state.middleName = action.payload;
      state.errors.middleNameError = {};
    },
    setLastName: (state, action) => {
      state.op = "U";
      state.lastName = action.payload;
      state.errors.lastNameError = {};
    },
    setFirstNameNep: (state, action) => {
      state.op = "U";
      state.firstNameNep = action.payload;
      state.errors.firstNameNepError = {};
      //  delete state.errors.firstNameNepError;
    },
    setMiddleNameNep: (state, action) => {
      state.op = "U";
      state.middleNameNep = action.payload;
      state.errors.middleNameNepError = {};
    },
    setLastNameNep: (state, action) => {
      state.op = "U";
      state.lastNameNep = action.payload;
      state.errors.lastNameNepError = {};
    },
    setDobAndMinor: (state, action) => {
      state.op = "U";
      state.dob = action.payload.date;
      state.errors.dobError = {};

      state.isMinor = action.payload.isMinor;
    },

    setDobAD: (state, action) => {
      state.op = "U";
      state.dobAD = action.payload;
      state.errors.dobADError = {};
    },

    setDobBs: (state, action) => {
      state.op = "U";
      state.dobBs = action.payload;
      state.errors.dobBsError = {};
    },

    setNrn: (state, action) => {
      state.op = "U";
      state.isNrn = action.payload;
    },
    setIsDisabled: (state, action) => {
      state.op = "U";
      state.isDisabled = action.payload;
      state.errors.isDisabledError = {};
    },
    setMaritalStatus: (state, action) => {
      state.op = "U";
      state.maritalStatus = action.payload;
      state.errors.isMaritalStatusError = {};
    },
    setGender: (state, action) => {
      state.op = "U";
      state.gender = action.payload;
      state.errors.genderError = {};
    },
    setNationality: (state, action) => {
      state.op = "U";
      state.nationality = action.payload;
      state.errors.nationalityError = {};
    },
    setNationalityDesc: (state, action) => {
      state.op = "U";
      state.nationalityDesc = action.payload;
    },
    setPan: (state, action) => {
      state.op = "U";
      state.pan = action.payload;
      state.errors.panError = {};
    },
    setNrnId: (state, action) => {
      state.nrnId = action.payload;
      state.errors.nrnIdError = {};
    },
    setNrnAddress: (state, action) => {
      state.nrnAddress = action.payload;
      state.errors.nrnAddressError = {};
    },
    setCitizenshipNo: (state, action) => {
      state.citizenshipNo = action.payload;
      state.errors.citizenshipNoError = {};
    },
    setIssuedDistrict: (state, action) => {
      state.issuedDistrict = action.payload;
      state.errors.issuedDistrictError = {};
    },
    setIssuedDistrictDesc: (state, action) => {
      state.issuedDistrictDesc = action.payload;
    },
    setIssuedDate: (state, action) => {
      state.issuedDate = action.payload;
      state.errors.issuedDateError = {};
    },

    setIssuedDateBs: (state, action) => {
      state.issuedDateBs = action.payload;
      state.errors.issuedDateBsError = {};
    },

    setNationalId: (state, action) => {
      state.nationalId = action.payload;
      state.errors.nationalIdError = {};
    },
    setPassportNo: (state, action) => {
      state.passportNo = action.payload;
      state.errors.passportNoError = {};
    },
    setExpiryDate: (state, action) => {
      state.expiryDate = action.payload;
      state.errors.expiryDateError = {};
    },
    setPersonDetailData: (state, action) => {
      Object.keys(action.payload).forEach(
        (key) => (state[key] = action.payload[key])
      );
      state.op = "N";
    },

    setFirstNameError: (state, action) => {
      // Ensure firstNameError exists before trying to set its properties
      if (!state.errors.firstNameError) {
        state.errors.firstNameError = {};
      }
      state.errors.firstNameError.message = action.payload.message;
      state.errors.firstNameError.section = action.payload.section;
    },

    setLastNameError: (state, action) => {
      // Ensure setLastNameError exists before trying to set its properties
      if (!state.errors.lastNameError) {
        state.errors.lastNameError = {};
      }
      state.errors.lastNameError.message = action.payload.message;
      state.errors.lastNameError.section = action.payload.section;
    },

    setMiddleNameError: (state, action) => {
      if (!state.errors.middleNameError) {
        state.errors.middleNameError = {};
      }
      state.errors.middleNameError.message = action.payload.message;
      state.errors.middleNameError.section = action.payload.section;
    },

    setFirstNameNepError: (state, action) => {
      state.errors.firstNameNepError = {};
      state.errors.firstNameNepError.message = action.payload.message;
      state.errors.firstNameNepError.section = action.payload.section;
    },

    setLastNameNepError: (state, action) => {
      state.errors.lastNameNepError = {};
      state.errors.lastNameNepError.message = action.payload.message;
      state.errors.lastNameNepError.section = action.payload.section;
    },

    setDobError: (state, action) => {
      state.errors.dobError = {};
      state.errors.dobError.message = action.payload.message;
      state.errors.dobError.section = action.payload.section;
    },

    setGenderError: (state, action) => {
      state.errors.genderError = {};
      state.errors.genderError.message = action.payload.message;
      state.errors.genderError.section = action.payload.section;
    },

    setNationalityError: (state, action) => {
      state.errors.nationalityError = {};
      state.errors.nationalityError.message = action.payload.message;
      state.errors.nationalityError.section = action.payload.section;
    },

    setNrnIdError: (state, action) => {
      state.errors.nrnIdError = {};
      state.errors.nrnIdError.message = action.payload.message;
      state.errors.nrnIdError.section = action.payload.section;
    },

    setNrnAddressError: (state, action) => {
      state.errors.nrnAddressError = {};
      state.errors.nrnAddressError.message = action.payload.message;
      state.errors.nrnAddressError.section = action.payload.section;
    },
    setCitizenshipNoError: (state, action) => {
      state.errors.citizenshipNoError = {};
      state.errors.citizenshipNoError.message = action.payload.message;
      state.errors.citizenshipNoError.section = action.payload.section;
    },
    setIssuedDistrictError: (state, action) => {
      state.errors.issuedDistrictError = {};
      state.errors.issuedDistrictError.message = action.payload.message;
      state.errors.issuedDistrictError.section = action.payload.section;
    },
    setIssuedDateError: (state, action) => {
      if (!state.errors.issuedDateError) {
        state.errors.issuedDateError = {};
      }
      state.errors.issuedDateError.message = action.payload.message;
      state.errors.issuedDateError.section = action.payload.section;
    },

    setIssuedFromError: (state, action) => {
      if (!state.errors.issuedFromError) {
        state.errors.issuedFromError = {};
      }
      state.errors.issuedFromError.message = action.payload.message;
      state.errors.issuedFromError.section = action.payload.section;
    },
    // setIssuedDateError: (state, action) => {
    //   state.errors.issuedDateError = {};
    //   state.errors.issuedDateError.message = action.payload.message;
    //   state.errors.issuedDateError.section = action.payload.section;
    // },

    setDocumentForMinor: (state, action) => {
      state.op = "U";
      state.documentForMinor = action.payload;
    },
    setPanError: (state, action) => {
      state.errors.panError = {};
      state.errors.panError.message = action.payload.message;
      state.errors.panError.section = action.payload.section;
    },
    setIsNrnError: (state, action) => {
      state.errors.isNrnError = {};
      state.errors.isNrnError.message = action.payload.message;
      state.errors.isNrnError.section = action.payload.section;
    },

    clearPersonalData: (state, action) => {
      state.op = "N";
    },
    clearPersonalDetailError: (state) => {
      state.errors = {};
    },
  },
});

export const {
  clearPersonalData,
  setDobAndMinor,
  setFirstName,
  setMiddleName,
  setLastName,
  setFirstNameNep,
  setMiddleNameNep,
  setLastNameNep,
  setNrn,
  setGender,
  setNationality,
  setNationalityDesc,
  setPan,
  setNrnId,
  setNrnAddress,
  setCitizenshipNo,
  setIssuedDistrict,
  setIssuedDate,
  setIssuedDateBs,
  setNationalId,
  setPassportNo,
  setExpiryDate,
  setIssuedDistrictDesc,
  setDobBs,
  setDobAD,
  setPersonDetailData,
  setFirstNameError,
  setMiddleNameError,
  setLastNameError,
  setFirstNameNepError,
  setLastNameNepError,
  setGenderError,
  setDobError,
  setNationalityError,
  setNrnAddressError,
  setNrnIdError,
  setIssuedDateError,
  setIssuedFromError,
  setIssuedDistrictError,
  setCitizenshipNoError,
  setPassportNoError,
  setExpiryDateError,
  setDocumentForMinor,
  setPanError,
  clearPersonalDetailError,
  setIsDisabled,
  setIsNrnError,
  setMaritalStatus,
} = personalDetailsSlice.actions;

export default personalDetailsSlice.reducer;

export const setDob = (date) => (dispatch) => {
  const isMinor = calculateAge(new Date(date)) < 18;

  dispatch(setDobAndMinor({ date, isMinor }));
  dispatch(disableSection({ code: "GD", flag: !isMinor }));
};

export const updateRouterData = (data) => (dispatch) => {
  const personDetail = data.personDetail;

  if (personDetail) {
    dispatch(
      setPersonDetailData({
        id: personDetail.id,
        customerId: data.id,
        tempKycId: data.tempKycId,
        permKycId: data.permKycId,
        isForBoid: data.isForBoid,
        isForMeroShareId: data.isForMeroShareId,
        dpId: data.dpId,
        status: data.status,
        op: "N",
      })
    );

    const pdd =
      personDetail.addressDetailList[0] &&
      (personDetail.addressDetailList[0].addressTypeId == 1
        ? personDetail.addressDetailList[0]
        : personDetail.addressDetailList[1]);
    const tdd =
      personDetail.addressDetailList[0] &&
      (personDetail.addressDetailList[0].addressTypeId == 1
        ? personDetail.addressDetailList[1]
        : personDetail.addressDetailList[0]);

    if (pdd || tdd) {
      const addressDetails = {
        ...(pdd
          ? {
            pid: pdd.id,
            pop: "N",
          }
          : {}),
        ...(tdd
          ? {
            id: tdd.id,
            op: "N",
          }
          : {}),
      };

      dispatch(setAddressDetailData(addressDetails));
    }

    const documentDetailList = personDetail.personDocumentDetailList
      .filter((d) => d.op !== "D")
      .map((d) => ({ ...d, issuedDate: d.issuedDate }));

    dispatch(resetDocumentListData(documentDetailList));

    if (personDetail.guardianDetail) {
      let guardianDetails = {};
      guardianDetails.id = personDetail.guardianDetail.id;
      guardianDetails.op = "N";

      if (personDetail.guardianDetail.personDetail) {
        guardianDetails.pid = personDetail.id;
        guardianDetails.pop = "N";
      }

      if (
        personDetail.guardianDetail.personDetail.addressDetailList &&
        personDetail.guardianDetail.personDetail.addressDetailList.length
      ) {
        const address =
          personDetail.guardianDetail.personDetail.addressDetailList[0];

        guardianDetails = {
          ...guardianDetails,
          paid: address.id,
          paop: "N",
        };
      }

      dispatch(setGuardianData(guardianDetails));

      if (personDetail.guardianDetail.personDetail.personDocumentDetailList) {
        const guardianDocumentList =
          personDetail.guardianDetail.personDetail.personDocumentDetailList
            .filter((d) => d.op !== "D")
            .map((d) => ({
              ...d,
              op: "N",
              issuedDate: new Date(d.issuedDate),
            }));

        dispatch(setGuardianDocumentListData(guardianDocumentList));
      }
    }

    if (
      personDetail.antiMoneyLaunderingList &&
      personDetail.antiMoneyLaunderingList.length
    ) {
      const antiMoneyLaunderingList = personDetail.antiMoneyLaunderingList.map(
        (aml) => ({
          id: aml.id,
          op: "N",
        })
      );
      dispatch(setAntiMoneyLaunderingDetailData(antiMoneyLaunderingList));
    }
    if (
      personDetail.occupationDetailList &&
      personDetail.occupationDetailList.length
    ) {
      const occupationDetailList = personDetail.occupationDetailList.map(
        (occupation) => ({
          id: occupation.id,
          op: "N",
        })
      );

      dispatch(setOccupationDetailData(occupationDetailList));

      if (
        personDetail.occupationDetailList[0].investmentCompanyList &&
        personDetail.occupationDetailList[0].investmentCompanyList.length
      )
        dispatch(
          resetOccupationInvetmentCompanyData(
            personDetail.occupationDetailList[0].investmentCompanyList
              .filter((i) => i.op !== "D")
              .map((companyDetails) => ({
                id: companyDetails.id,
                companyName: companyDetails.name,
                companyDesignation: companyDetails.designation,
                op: "N",
              }))
          )
        );

      if (
        personDetail.occupationDetailList[0].investmentCompanyRelationList &&
        personDetail.occupationDetailList[0].investmentCompanyRelationList.length
      )
        dispatch(
          resetOccupationInvestmentCompanyRelationList(
            personDetail.occupationDetailList[0].investmentCompanyRelationList
              .filter((i) => i.op !== "D")
              .map((companyDetails) => ({
                id: companyDetails.id,
                companyNameOrRelation: companyDetails.name,
                companyNameRelation: companyDetails.orgName,
                companyRelationDesignation: companyDetails.designation,
                fromAd: companyDetails.dataFrom,
                toAd: companyDetails.dataTo,
                companyRelationDesignationDesc: companyDetails.designationDesc,
                designationOthers: companyDetails.designationOthers,
                op: "N",
              }))
          )
        );
    }

    if (personDetail.familyDetailList && personDetail.familyDetailList.length) {
      const familyDetailList = personDetail.familyDetailList
        .filter((f) => f.op !== "D")
        .map((family) => ({
          id: family.id,
          pid: family.personDetail.id,
          relativeTypeId: family.relationTypeId,
          firstName: family.personDetail.fname,
          middleName: family.personDetail.mname,
          lastName: family.personDetail.lname,
          firstNameNep: family.personDetail.fnameNep,
          middleNameNep: family.personDetail.mnameNep,
          lastNameNep: family.personDetail.lnameNep,
          op: family.op,
          pop: family.personDetail.op,
        }));

      dispatch(resetFamilyDetailData(familyDetailList));
    }
  }
  if (personDetail.biometricsDetailsList)
    dispatch(
      setBiometricsDetailsData(personDetail.biometricsDetailsList)
    );
};

export const setRouterData = (data) => (dispatch) => {
  console.log("data: ", data);
  const personDetail = data.personDetail;
  const pdd =
    (personDetail.addressDetailList[0] &&
      (personDetail.addressDetailList[0].addressTypeId === 1
        ? personDetail.addressDetailList[0]
        : personDetail.addressDetailList[1])) ||
    {};
  const tdd =
    (personDetail.addressDetailList[0] &&
      (personDetail.addressDetailList[0].addressTypeId === 1
        ? personDetail.addressDetailList[1]
        : personDetail.addressDetailList[0])) ||
    {};

  console.log("data22");
  const addressDetails = {
    id: tdd.id,
    pid: pdd.id,
    perCountry: pdd.countryCd,
    perState: pdd.stateCd,
    perDistrict: pdd.districtCd,
    perMunicipality: pdd.municipalityCd,
    perWard: pdd.ward,
    perTole: pdd.tole,
    perBlockNo: pdd.blockNo,
    perTelephoneNo: pdd.phoneNo,
    country: tdd.countryCd,
    state: tdd.stateCd,
    website: tdd.website,
    district: tdd.districtCd,
    municipality: tdd.municipalityCd,
    ward: tdd.ward,
    tole: tdd.tole,
    blockNo: tdd.blockNo,
    telephoneNo: tdd.phoneNo,
    emailId: tdd.email,
    mobileNo: tdd.mobileNo,
    LatLng: {
      mapPosition: { lat: tdd.lat, lng: tdd.lng },
      markerPosition: { lat: tdd.lat, lng: tdd.lng },
    },
    pop: "N",
    op: "N",
    perCountryDesc: pdd.countryDesc,
    perStateDesc: pdd.stateDesc,
    perDistrictDesc: pdd.districtDesc,
    perMunicipalityDesc: pdd.municipalityDesc,
    countryDesc: tdd.countryDesc,
    stateDesc: tdd.stateDesc,
    districtDesc: tdd.districtDesc,
    municipalityDesc: tdd.municipalityDesc,
    hasPermanentAddressSame: pdd.hasPermanentAddressSame
  };

  const antiMoneyLaunderingList = personDetail.antiMoneyLaunderingList.map((aml) => ({
    ...aml,
    relatedHighRankingOfficial: aml.relatedHighRankingOfficialName ? true : false,//after this just for checkbox show
    beneficiary: aml.beneficiaryName ? true : false,
    felonyState: aml.felony ? true : false
  }));

  const occupationDetailList = personDetail.occupationDetailList.map(
    (occupation) => ({
      id: occupation.id,
      financialDetails: occupation.financialStatus,
      designation: occupation.designation,
      address: occupation.address,
      organizationName: occupation.orgName,
      occupationType: occupation.occupationTypeId,
      occupationTypeOthers: occupation.occupationTypeOthers,
      businessType: occupation.businessTypeId,
      businessTypeOthers: occupation.businessTypeOthers,
      docId: occupation.idNo,
      op: "N",
      companyDetailsList: occupation.investmentCompanyList.map(
        (companyDetails) => ({
          id: companyDetails.id,
          companyName: companyDetails.name,
          companyDesignation: companyDetails.designation,
          op: "N",
          companyDesignationDesc: companyDetails.designationDesc,
          designationOthers: companyDetails.designationOthers
        })
      ),
      companyRelationDetailsList: occupation.investmentCompanyRelationList.map(
        (companyDetails) => ({
          id: companyDetails.id,
          companyNameOrRelation: companyDetails.name,
          companyNameRelation: companyDetails.orgName,
          companyRelationDesignation: companyDetails.designation,
          fromAd: companyDetails.dataFrom,
          toAd: companyDetails.dataTo,
          companyRelationDesignationDesc: companyDetails.designationDesc,
          designationOthers: companyDetails.designationOthers,
          op: "N",
        })
      ),
      securtitesTrading:
        occupation.investmentCompanyList &&
          occupation.investmentCompanyList.length
          ? "Y"
          : "N",
      businessTypeDesc: occupation.businessTypeDesc,
      occupationTypeDesc: occupation.occupationTypeDesc,
      financialDetailsDesc: occupation.financialStatusDesc,
    })
  );
  const personDocumentDetailList = personDetail.personDocumentDetailList.map(
    (d) => ({ ...d, op: "N", issuedDate: d.issuedDate })
  );

  const locationType =
    personDocumentDetailList &&
      personDocumentDetailList.find(
        (d) => d.documentTypeId === "MP" && d.fileId
      ) ?
      "I" : 'G';

  addressDetails.locationType = locationType;

  const familyDetailList = personDetail.familyDetailList.map((family) => ({
    id: family.id,
    pid: family.personDetail.id,
    relativeTypeId: family.relationTypeId,
    firstName: family.personDetail.fname,
    middleName: family.personDetail.mname,
    lastName: family.personDetail.lname,
    firstNameNep: family.personDetail.fnameNep,
    middleNameNep: family.personDetail.mnameNep,
    lastNameNep: family.personDetail.lnameNep,
    op: "N",
    pop: "N",
    relationTypeDesc: family.relationTypeDesc,
  }));
  let guardianDetails = {};
  let guardianDocumentList = [];

  if (personDetail.guardianDetail) {
    guardianDetails.relationship = personDetail.guardianDetail.relationTypeId;
    guardianDetails.id = personDetail.guardianDetail.id;
    guardianDetails.relationshipDesc =
      personDetail.guardianDetail.relationTypeDesc;
    guardianDetails.relationshipOthers =
      personDetail.guardianDetail.relationTypeOthers;
    if (personDetail.guardianDetail.personDetail) {
      if (personDetail.guardianDetail.personDetail.biometricsDetailsList != null) {
        guardianDetails = {
          ...guardianDetails,
          ...personDetail.guardianDetail.personDetail.biometricsDetailsList
        };
      }
      const person = personDetail.guardianDetail.personDetail;
      guardianDetails.firstName = person.fname;
      guardianDetails.middleName = person.mname;
      guardianDetails.lastName = person.lname;
      guardianDetails.pid = person.id;
      guardianDetails.firstNameNep = person.fnameNep;
      guardianDetails.middleNameNep = person.mnameNep;
      guardianDetails.lastNameNep = person.lnameNep;
      guardianDetails.pan = person.pan;
    }

    if (
      personDetail.guardianDetail.personDetail.addressDetailList &&
      personDetail.guardianDetail.personDetail.addressDetailList.length
    ) {
      const address =
        personDetail.guardianDetail.personDetail.addressDetailList[0];

      guardianDetails = {
        ...guardianDetails,
        ...{
          paid: address.id,
          country: address.countryCd,
          state: address.stateCd,
          district: address.districtCd,
          municipality: address.municipalityCd,
          ward: address.ward,
          tole: address.tole,
          blockNo: address.blockNo,
          telephoneNo: address.phoneNo,
          emailId: address.email,
          mobileNo: address.mobileNo,
          fax: address.fax,
          countryDesc: address.countryDesc,
          stateDesc: address.stateDesc,
          districtDesc: address.districtDesc,
          municipalityDesc: address.municipalityDesc,
        },
      };
    }

    if (personDetail.guardianDetail.personDetail.personDocumentDetailList) {
      guardianDocumentList =
        personDetail.guardianDetail.personDetail.personDocumentDetailList.map(
          (d) => ({ ...d, op: "N", issuedDate: new Date(d.issuedDate) })
        );
    }
  }

  const documentForMinor =
    personDocumentDetailList &&
    (
      personDocumentDetailList.find(
        (d) =>
          (d.documentTypeId === "CZ" || d.documentTypeId === "BC") &&
          (d.fileId || d.docId)
      ) || {}
    ).documentTypeId;

  const boidList = data.boIdList.map((boid) => ({
    id: boid.id,
    boid: boid.boId,
    dpId: boid.dpId,
    isForwarded: boid.isForwarded,
    op: "N",
    dpIdDesc: boid.dpIdDesc,
    fullBoId: boid.fullBoId
  }));
  const bankAccountDeatilList = data.bankAccountDetailList.map(
    (bankAccount) => ({
      id: bankAccount.id,
      bankAccountNumber: bankAccount.accountNo,
      typesOfBankAccount: bankAccount.accountType,
      isPrimaryAccount: bankAccount.isPrimaryAccount,
      bank: bankAccount.bankId,
      op: "N",
      bankBranch: bankAccount.bankBranchCd,
      bankDesc: bankAccount.bankDesc,
      bankBranchDesc: bankAccount.bankBranchDesc,
      typesOfBankAccountDesc: bankAccount.bankAccountTypeDesc,
    })
  );
  dispatch(
    setBiometricsDetailsData(personDetail.biometricsDetailsList)
  );
  dispatch(
    setMainRouterData({
      customerId: data.id,
      formType: data.type || "I",
      tempKycId: data.tempKycId,
      permKycId: data.permKycId,
      isForBoid: data.isForBoid,
      isForMeroShareId: data.isForMeroShareId,
      dpId: data.dpId,
      status: data.status,
      criticalDataChanged: data.criticalDataChanged,
    })
  );

  dispatch(
    setPersonDetailData({
      id: personDetail.id,
      customerId: data.id,
      tempKycId: data.tempKycId,
      permKycId: data.permKycId,
      isForBoid: data.isForBoid,
      isForMeroShareId: data.isForMeroShareId,
      dpId: data.dpId,
      documentForMinor,
      status: data.status,
      firstName: personDetail.fname,
      middleName: personDetail.mname,
      lastName: personDetail.lname,
      firstNameNep: personDetail.fnameNep,
      middleNameNep: personDetail.mnameNep,
      lastNameNep: personDetail.lnameNep,
      gender: personDetail.gender,
      dob: personDetail.dob && new Date(personDetail.dob),
      //  dobBs: personDetail.dob && adToBs(personDetail.dob),
      dobBs: personDetail.dobBs,
      nationality: personDetail.countryCd,
      pan: personDetail.pan,
      isMinor: personDetail.isMinor,
      isNrn: personDetail.isNrn,
      op: "N",
      nationalityDesc: personDetail.nationalityDesc,
      isDisabled: personDetail.isDisabled,
      documentForMinor: personDetail.documentForMinor,
      isSignature: personDetail.isSignature,
      isBiometric: personDetail.isBiometric,
    })
  );

  dispatch(setAddressDetailData(addressDetails));

  dispatch(setAntiMoneyLaunderingDetailData(antiMoneyLaunderingList));

  dispatch(setOccupationDetailData(occupationDetailList));

  dispatch(setFamilyDetailData(familyDetailList));

  dispatch(setGuardianData(guardianDetails));

  dispatch(setGuardianDocumentListData(guardianDocumentList));

  dispatch(setBoidData(boidList));

  if (!boidList.length && data.dpId)
    dispatch(
      setBoidOtherData({
        createBoid: data.isForBoid,
        fdpId: data.dpId,
        createMeroShareId: data.isForMeroShareId,
      })
    );
  else
    dispatch(
      setBoidOtherData({
        createBoid: data.isForBoid,
        createMeroShareId: data.isForMeroShareId,
      })
    );

  dispatch(setBankDetailsData(bankAccountDeatilList));

  dispatch(setDynamicFieldData(data.dynamicDataList));
  dispatch(setDocumentListData(personDocumentDetailList));
  dispatch(disableSection({ code: "GD", flag: !personDetail.isMinor }));
};

export const clearRouterData = () => (dispatch) => {
  dispatch(clearPersonalData());
  dispatch(clearAddressData());
  dispatch(clearOccupationData());
  dispatch(clearFamilyData());
  dispatch(clearGuardianData());
  dispatch(clearBoidData());
  dispatch(clearBankData());
  dispatch(clearDynamicData());
  dispatch(clearDocumentData());
};
